var KeywordBar, base, placeholderState, unparam, whichKeyAlias;

unparam = require('../../general/m_unparam');

whichKeyAlias = require('../common/m_keypress').whichKeyAlias;

placeholderState = require('../helper/m_common').placeholderState;

module.exports = KeywordBar = (function() {
  function KeywordBar(arg) {
    var el, env, initialKeyword;
    el = arg.el, env = arg.env;
    this.$el = el;
    this.env = env || 'desktop';
    this.$input = this.$el.find('#search, #ls-search');
    this.placeholder = this.$input.attr('placeholder');
    this.bind();
    if (!_.isBlank(initialKeyword = unparam().query)) {
      placeholderState.set(this.$input, 'hide');
      this.val(initialKeyword);
    }
    return;
  }

  KeywordBar.prototype.bind = function() {
    return this.$input.on('keydown', (function(_this) {
      return function(e) {
        if (whichKeyAlias(e) === 'Enter') {
          _this.$el.trigger('submit');
        }
      };
    })(this));
  };

  KeywordBar.prototype.setKeyword = KeywordBar.val;

  KeywordBar.prototype.val = function(value) {
    var currentVal;
    if (value != null) {
      return this.$input.val(value).removeClass('prompting');
    } else {
      currentVal = this.$input.val();
      if (_.isBlank(currentVal) || currentVal === this.placeholder) {
        return null;
      }
      return currentVal.trim();
    }
  };

  return KeywordBar;

})();

if ((base = window.Groupon.Modules).SearchBar == null) {
  base.SearchBar = {};
}

_.extend(window.Groupon.Modules.SearchBar, {
  KeywordBar: KeywordBar
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvc3JjL2Zyb250ZW5kL2hlbHBlci9zZWFyY2gvdmlldy9tX2tleXdvcmRfYmFyLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9hcmljaHRlci9yZXBvc2l0b3JpZXMvc2xzL3NyYy9mcm9udGVuZC9oZWxwZXIvc2VhcmNoL3ZpZXcvbV9rZXl3b3JkX2Jhci5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxPQUFBLEdBQXVCLE9BQUEsQ0FBUSx5QkFBUjs7QUFDckIsZ0JBQXFCLE9BQUEsQ0FBUSxzQkFBUjs7QUFDckIsbUJBQXFCLE9BQUEsQ0FBUSxvQkFBUjs7QUFFdkIsTUFBTSxDQUFDLE9BQVAsR0FBdUI7RUFDUixvQkFBQyxHQUFEO0FBQ1gsUUFBQTtJQURhLGFBQUk7SUFDakIsSUFBQyxDQUFBLEdBQUQsR0FBTztJQUNQLElBQUMsQ0FBQSxHQUFELEdBQU8sR0FBQSxJQUFPO0lBQ2QsSUFBQyxDQUFBLE1BQUQsR0FBVSxJQUFDLENBQUEsR0FBRyxDQUFDLElBQUwsQ0FBVSxxQkFBVjtJQUNWLElBQUMsQ0FBQSxXQUFELEdBQWUsSUFBQyxDQUFBLE1BQU0sQ0FBQyxJQUFSLENBQWEsYUFBYjtJQUVmLElBQUMsQ0FBQSxJQUFELENBQUE7SUFFQSxJQUFBLENBQU8sQ0FBQyxDQUFDLE9BQUYsQ0FBVSxjQUFBLEdBQWlCLE9BQUEsQ0FBQSxDQUFTLENBQUMsS0FBckMsQ0FBUDtNQUNFLGdCQUFnQixDQUFDLEdBQWpCLENBQXFCLElBQUMsQ0FBQSxNQUF0QixFQUE4QixNQUE5QjtNQUNBLElBQUMsQ0FBQSxHQUFELENBQUssY0FBTCxFQUZGOztBQUdBO0VBWFc7O3VCQWFiLElBQUEsR0FBTSxTQUFBO1dBQ0osSUFBQyxDQUFBLE1BQU0sQ0FBQyxFQUFSLENBQVcsU0FBWCxFQUFzQixDQUFBLFNBQUEsS0FBQTthQUFBLFNBQUMsQ0FBRDtRQUNwQixJQUFHLGFBQUEsQ0FBYyxDQUFkLENBQUEsS0FBb0IsT0FBdkI7VUFDRSxLQUFDLENBQUEsR0FBRyxDQUFDLE9BQUwsQ0FBYSxRQUFiLEVBREY7O01BRG9CO0lBQUEsQ0FBQSxDQUFBLENBQUEsSUFBQSxDQUF0QjtFQURJOzt1QkFNTixVQUFBLEdBQVksVUFBQyxDQUFBOzt1QkFFYixHQUFBLEdBQUssU0FBQyxLQUFEO0FBQ0gsUUFBQTtJQUFBLElBQUcsYUFBSDthQUNFLElBQUMsQ0FBQSxNQUNDLENBQUMsR0FESCxDQUNPLEtBRFAsQ0FFRSxDQUFDLFdBRkgsQ0FFZSxXQUZmLEVBREY7S0FBQSxNQUFBO01BS0UsVUFBQSxHQUFhLElBQUMsQ0FBQSxNQUFNLENBQUMsR0FBUixDQUFBO01BRWIsSUFBZSxDQUFDLENBQUMsT0FBRixDQUFVLFVBQVYsQ0FBQSxJQUF5QixVQUFBLEtBQWMsSUFBQyxDQUFBLFdBQXZEO0FBQUEsZUFBTyxLQUFQOzthQUNBLFVBQVUsQ0FBQyxJQUFYLENBQUEsRUFSRjs7RUFERzs7Ozs7OztNQWFlLENBQUMsWUFBYTs7O0FBQ3BDLENBQUMsQ0FBQyxNQUFGLENBQVMsTUFBTSxDQUFDLE9BQU8sQ0FBQyxPQUFPLENBQUMsU0FBaEMsRUFBMkM7RUFBQyxZQUFBLFVBQUQ7Q0FBM0MifQ==
